/* Update Collection Tab in view based on dropdown selection. */
function update_collection_tab(item){
    /* Script used to turn off and on the correct tab content. */
    const tabs = item.closest('.collection-tabs').querySelectorAll('.tab-content');
    for (let i = 0; i < tabs.length; i++) {
        if( tabs[i].closest('.collection-tabs').querySelector('.active') ){
            tabs[i].closest('.collection-tabs').querySelector('.active').classList.remove('active');
            tabs[i].closest('.collection-tabs').querySelector('.visible').classList.remove('visible');
        }
        
        /* This below seems to be slowing the tab switching. Need to fix script. */
        tabs[i].closest('.collection-tabs').querySelector('.tab[data-tab="'+ item.dataset.tab +'"]').classList.add('active');
        tabs[i].closest('.collection-tabs').querySelector('.tab-content[data-tab="'+ item.dataset.tab +'"]').classList.add('visible');
    }
}

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const tab = urlParams.get('tab');
const requestedTab = document.querySelector('.collection-tabs .tab[data-variable="'+tab+'"');
const firstTab = document.querySelector('.collection-tabs button.tab:first-child');

if( tab && requestedTab ){
    requestedTab.click();
}else if( firstTab ){
    firstTab.click();
}
/*
document.addEventListener("click", function(e){
    const collectionTab = (e.target.classList.contains('tab') ? e.target : false);
    if (e.target == collectionTab) {
        document.getElementById("SkipToMainContent").scrollIntoView({ behavior: "smooth", block: "start" });
    }

});
*/